import { Injectable } from "@angular/core";
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { Router } from "@angular/router";
import {ChatService} from "../services/chat.service";
import {AuthService} from "../services/auth.service";
import {CookieService} from "../services/cookie.service";
import {StorageService} from "../services/storage.service";
import {Store} from "../store";

@Injectable()
export class ErrorRequestInterceptor implements HttpInterceptor {
    constructor(private router: Router,
        private store: Store,
        private cookieService: CookieService,
            private storageService: StorageService,
        ) {}

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<any> {
        return next.handle(request).pipe(
            catchError((error) => {
                if (error?.error?.code === "AUTH-0002") {
                    // Only tear down and bounce to a fresh login when there WAS an
                    // authenticated session that has gone stale. On the unauthenticated
                    // login page an AUTH-0002 is expected (an eager guarded bootstrap
                    // call before sign-in), and reacting to it — clear cookies + navigate
                    // to /?resetLogin=true, which calls logout() — churns an unnecessary
                    // logout on every login-page load and can bounce a mid-login user.
                    if (!this.store.selectForLocal('loggedIn')) {
                        return throwError(() => error);
                    }
                    this.cookieService.remove();
                    this.storageService.remove();
                    this.store.set('token', '');
                    this.store.set('loggedIn', false);
                    this.store.set('user', undefined);

                    this.router.navigate(
                        ['/'],
                        {
                            queryParams: {
                                resetLogin: true
                            }
                        }
                    )
                    return of({});
                }
                return throwError(() => error);
            })
        );
    }
}
